import React from 'react';
import PropTypes from 'prop-types';
import utils from '@utils';

/**
 * Displays the available funds in a formatted row with a label and value.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {number} props.availableFunds - The amount of available funds to display.
 * @returns {JSX.Element} The rendered component showing available funds.
 */
const AvailableFundsDisplay = ({ availableFunds }) => {
  const { lang } = global;

  return (
    <div className={`row ${availableFunds === 0 ? 'text-muted' : ''}`}>
      <div className="col-xs-9">
        <strong>{lang.t("Available Funds")}</strong>
      </div>
      <div className="col-xs-3">
        {utils.currencyFormatter(availableFunds)}
      </div>
    </div>
  );
};

AvailableFundsDisplay.propTypes = {
  availableFunds: PropTypes.number.isRequired
};

export default AvailableFundsDisplay;
